import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';
import { apiUc as http } from '../../../http/index';

class ExtensionService extends ServiceCRUD {
  constructor() {
    super('/api/ramais');
  }

  createExtensionRange(data) {
    return http.post(`/api/ramais-range`, data);
  }

  updateExtensionSet(data) {
    return http.put(`/api/ramais-range`, data);
  }

  getAllExtension(
    page,
    size,
    showDisable = false,
    querySearch = '',
    queryParams = {},
    sortBy = '',
    order = ''
  ) {
    if (!page || !size)
      return http.get(`${this.path}`, {
        params:
          Object.keys(queryParams).length > 0
            ? { ...queryParams, showDisable }
            : { showDisable }
      });

    return http.get(`${this.path}`, {
      headers: {
        limit: size,
        offset: size * (page - 1)
      },
      params: {
        showDisable: showDisable,
        q: querySearch,
        order: order?.toUpperCase(),
        sortBy: sortBy,
        ...queryParams
      }
    });
  }

  getAllShowDisableNew = (showDisable) => {
    return http.get(`${this.path}/all?showDisable=${showDisable}`);
  };
}

export default new ExtensionService();
